// Update these values to match those of your Server URL, DriveWorks Group Alias
// and Project Name that you wish to be rendered.

const config = {
    serverUrl: "https://builder.jegrill.com",
    groupAlias: "JE",
    driveAppName: "JECPQOrder",
    // (Optional) Set Specification ping interval - in seconds
    // A Specification will timeout after a configured period of inactivity (see DriveWorksConfigUser.xml).
    // This function prevents a Specification timing out as long as the page is in view.
    // Disable the ping by changing the setting to 0
    specificationPingInterval: 30,
    DriveWorksLiveClientConfig: {
        downloadStyle: "query-string"
    },
    portal: {
        groupAlias: "JE",
        driveAppName: "JECPQ", 
    },
    configuratorHeight: {
        product: 650,
        catalog: 575,
        basket: 700,
    },
    login: {
        //redirectUrl: "dashboard.html",
        redirectUrl: DriveworksData.dealer_portal_url,
    },
    logout: {
        //redirectUrl: "index.html",
        redirectUrl: DriveworksData.dealer_portal_url,
    },
    dashboard: {
        //redirectOnClose: "index.html",
        //redirectOnCancel: "index.html",
        redirectOnClose: DriveworksData.site_url,
        redirectOnCancel: DriveworksData.site_url,
    },
    driveApp: {
        //redirectOnClose: "index.html",
        //redirectOnCancel: "index.html",
        redirectOnClose: DriveworksData.site_url,
        redirectOnCancel: DriveworksData.site_url,
    },

    // credentials
    credentials: {
        username: "Sales",
        password: "",
    },

    // CPQ constant in the JECPQOrder DriveApp that receives the customer details
    // captured by the website gate form, as a JSON string - see
    // setFormDataConstant() in dw-client-functions.js. Set to "" to stop
    // sending it.
    //
    // ProjectData is an existing constant DriveWorks asked us to reuse, rather
    // than creating a new one. The basket used to send it as the text "Basket",
    // which neither side was reading - see Basket.js.
    formDataConstant: "ProjectData",
};